import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { CrystallisationDetailsSection } from "../../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownTypeOption } from "../../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { QuoteModel } from "../../../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DIAC } from "../../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import {
    getChooseAssetsToSellTable,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { IllHealth } from "../../../../Common/SIPP/DrawdownDetails/IllHealth";
import { DrawdownCalculationAction } from "../../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { QuoteInstructionStore } from "../../../Store/Variable";
import { NewQuoteAction } from "../../../Actions/NewQuoteAction";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { PensionProtection } from "../../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ChooseAssetsToSellAssets } from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { DeferredFundWarningMessage, IsRestrictedToPensionContributionWarningText } from "../../../../Common/Resource/Contents";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { PensionOption } from "../../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { AllowanceDetails } from "../../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { PCLSSection } from "../../../../Common/SIPP/DrawdownDetails/PCLSSection";
import { TableKeys } from "../../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: QuoteModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ assetsTable: getChooseAssetsToSellTable(this.props.data.PensionQuote) });
        if (
            !LessThanAge(55, JsonDateParser.toDate(this.props.data?.ClientDetails?.DateOfBirth)) &&
            !this.props.data?.PensionQuote?.DrawdownModel?.InstructionId
        ) {
            this.setState({ isLoading: true });
            const params = getQueryParameters();
            DrawdownCalculationAction.postDrawdown(
                this.props.data?.PensionQuote?.HierarchyId,
                null,
                (drawdownModel: DrawdownModel) => {
                    NewQuoteAction.getQuoteInstruction(params["id"]);
                    this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                }
            );
        }

        this.checkDeferredFunds(this.state.assetsTable);
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if (this.props.data?.PensionQuote?.HasPensionProtection && this.props.data?.PensionQuote?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.PensionQuote?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.HasStopWarning
        ) {
            return false;
        }
        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.HasFailedStandaloneLumpSumValidation
        ) {
            return false;
        }

        if (
            this.props.data?.PensionQuote?.DrawdownModel?.PensionOption == PensionOption.UFPLS &&
            this.props.data?.PensionQuote?.DrawdownModel?.UfplsWithdrawal?.WithdrawalAmount >
                this.props.data?.PensionQuote?.DrawdownModel?.DrawdownCalculations?.AvailableCash
        ) {
            return false;
        }
        return flag && !isRestrictedProtection;
    }

    private checkDeferredFunds(assets: ChooseAssetsToSellAssets[]) {
        let deferredInstrumentCodes = assets.filter((a) => a.IsDeferred).map((o) => o.Assets);
        let message = DeferredFundWarningMessage.CannotSwitchFromDeferredFundWarning.replace(
            "<InstrumentCode>",
            deferredInstrumentCodes.join(",")
        );
        this.props.showErrorMsgPopUp([message]);
    }

    private getComponentProps = (data: QuoteModel, onChange) => {
        return {
            data: data?.PensionQuote?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                    v,
                    data.PensionQuote,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType || QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.PensionQuote?.DrawdownModel?.DrawdownType;
        let _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.PensionQuote.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        NewQuoteAction.saveQuoteInstruction(1, _data, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data: QuoteModel) {
        return (
            LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)) &&
            !data?.PensionQuote?.DrawdownModel?.InstructionId
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum =
            data?.SelectedProducts?.find((ele) => ele.SubAccountType == SubAccountType.JuniorSipp)?.PensionType ==
            PensionType.ImmediateTaxFreeLumpSum;
        if (this.needIllHealth(data)) {
            return (
                <PartLoading isLoading={this.state.isLoading}>
                    <IllHealth
                        {...this.getComponentProps(data, onChange)}
                        getDrawdownModel={() => {
                            this.setState({ isLoading: true });
                            const params = getQueryParameters();
                            DrawdownCalculationAction.postDrawdown(
                                this.props.data?.PensionQuote?.HierarchyId,
                                null,
                                (drawdownModel: DrawdownModel) => {
                                    NewQuoteAction.getQuoteInstruction(params["id"]);
                                    this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                                },
                                true
                            );
                        }}
                    />
                </PartLoading>
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.JuniorSipp)}
                >
                    <h2>Drawdown details</h2>
                    <PensionProtection
                        {...this.props}
                        onRef={(ref) => this.appendChild(ref)}
                        data={data?.PensionQuote}
                        onChange={(v) => this.onDataChange(onChange, v, data, "PensionQuote")}
                        process={ProcessType.Quote}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    />
                    <ProtectionInformation
                        {...this.getComponentProps(data, onChange)}
                        process={ProcessType.Quote}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                    />

                    <DrawdownTypeOption
                        isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                        originType={
                            this.state.originType ||
                            QuoteInstructionStore.getData()?.PensionQuote?.DrawdownModel?.DrawdownType
                        }
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        activityType={data?.ActivityType}
                        PersonalRecommendation={true}
                    />
                    {data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                        <RegularCrystallisation
                            {...this.getComponentProps(data, onChange)}
                            process={ProcessType.Quote}
                            doCalculation={() => this.doCalculation()}
                        />
                    )}

                    {(data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Capped ||
                        data?.PensionQuote?.DrawdownModel?.DrawdownType == DrawdownType.Flexible) && (
                        <CrystallisationDetailsSection
                            isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                            modelData={this.props.data?.PensionQuote}
                            processType={ProcessType.Quote}
                            cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                            doCalculation={() => this.doCalculation()}
                            {...this.getComponentProps(data, onChange)}
                            pensionProtection={data?.PensionQuote?.PensionProtection}
                        />
                    )}

                    {(data?.PensionQuote?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.PensionQuote?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                        !hasPrimaryProtection(data?.PensionQuote?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.PensionQuote?.PensionProtection) && (
                            <>
                                <LTABreakdownDetails
                                    doCalculation={() => this.doCalculation()}
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.Quote}
                                    lessThan75={ageLessThan75}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                                />
                            </>
                        )}
                    <AllowanceDetails
                        doCalculation={() => this.doCalculation()}
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                        process={ProcessType.Quote}
                    />
                    <PCLSSection {...this.getComponentProps(data, onChange)} data={data.PensionQuote.DrawdownModel} />
                    <TaxFreeLumpSumPayment
                        doCalculation={this.doCalculation}
                        process={ProcessType.Quote}
                        pensionProtection={data?.PensionQuote?.PensionProtection}
                        {...this.getComponentProps(data, onChange)}
                        lessThan75={LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth))}
                        hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionQuote)}
                    />

                    {data?.PensionQuote?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                        <DIAC
                            {...this.getComponentProps(data, onChange)}
                            modelData={this.props.data?.PensionQuote}
                            existingAccount={false}
                        />
                    )}
                    <OAC
                        readonly={true}
                        type={SubAccountType.JuniorSipp}
                        onChange={(v) => {}}
                        data={{
                            OngoingAdviceCharge:
                                data?.PensionQuote?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                        }}
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                    <ChargesOnIllustration {...this.getComponentProps(data, onChange)} />

                    {showChooseAssetstoSell(data?.PensionQuote?.DrawdownModel, ChooseAssetsToSellFor.Drawdown) &&
                        !isImmediateTaxFreeLumpSum && (
                            <>
                                <hr />
                                <ChooseAssetsToSell
                                    {...this.getComponentProps(data, onChange)}
                                    tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                    assets={this.state.assetsTable}
                                />
                                {!data?.PensionQuote?.DrawdownModel?.IsAcrossAllAssets && (
                                    <ChooseAssetsToSellTable
                                        modelData={data?.PensionQuote?.DrawdownModel}
                                        data={
                                            data?.PensionQuote?.DrawdownModel?.PensionCommencementLumpSumAllocations ||
                                            []
                                        }
                                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                        tableData={this.state.assetsTable}
                                        onRef={(ref) => this.appendChild(ref)}
                                        onChange={(v) => {
                                            this.onDataChange(
                                                (changes) => this.onDataChange(onChange, changes, data, "PensionQuote"),
                                                { PensionCommencementLumpSumAllocations: v },
                                                data.PensionQuote,
                                                "DrawdownModel"
                                            );
                                        }}
                                        processType={ProcessType.Quote}
                                        reason={ChooseAssetsToSellFor.Drawdown}
                                    />
                                )}
                            </>
                        )}
                </WizardLinter>
            </PartLoading>
        );
    }
}
